import React, { useCallback, useContext } from "react";
import { FindAStoreContext, Place } from "../contexts/findAStore";
import NoResults from "cobra-find-a-store/src/components/no-results";
import StoreList from "cobra-find-a-store/src/components/store-list";
import SearchBar from "./search";
import BotRecaptcha from "./bot-recaptcha";
import { Store } from "../types";

interface PanelContainerProps {
  googleLoaded: boolean;
  isBot: boolean;
  setIsBot: Function;
  children?: JSX.Element | JSX.Element[];
  brands: string[];
  store?: Store;
}

const PanelContainer = (props: PanelContainerProps) => {
  const {
    state: { storesInView, place },
    dispatch,
  } = useContext(FindAStoreContext);
  const setPlace = (place: Place) =>
    dispatch({ type: "SetPlace", payload: place });

  const _getPlace = useCallback((place: Place) => {
    setPlace(place);
  }, []);

  return (
    <div
      sx={{
        width: ["100%", null, null, "35%"],
        height: ["50%", null, null, "100%"],
        display: "flex",
        flexDirection: "column",
        minHeight: "0",
      }}
    >
      <div
        sx={{
          flexGrow:
            storesInView.length > 0 || (place && storesInView.length == 0)
              ? 0.001
              : 1,
          transition: "flex-grow 500ms",
          display: "flex",
          alignItems: "center",
          minHeight: "69.6px",
        }}
      >
        <div
          sx={{
            backgroundColor: "#fff",
            width: "100%",
          }}
        >
          {props.googleLoaded ? (
            <SearchBar
              getPlace={_getPlace}
              brands={props.brands}
              store={props.store}
            />
          ) : props.isBot ? (
            <BotRecaptcha onChange={() => props.setIsBot(false)} />
          ) : null}
        </div>
      </div>
      <div
        sx={{
          flexGrow:
            storesInView.length > 0 || (place && storesInView.length == 0)
              ? 1
              : 0.001,
          transition: "flex-grow 500ms",
          overflowY: "auto",
        }}
      >
        {place && storesInView.length == 0 ? (
          <NoResults />
        ) : storesInView.length > 0 ? (
          <StoreList brands={props.brands} />
        ) : (
          <div></div>
        )}
      </div>
    </div>
  );
};

export default PanelContainer;
